module.exports = ".blur {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  -webkit-filter: blur(4px);\n          filter: blur(4px);\n  -webkit-transition: -webkit-filter .2s;\n  transition: -webkit-filter .2s;\n  transition: filter .2s;\n  transition: filter .2s, -webkit-filter .2s; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/home/home.component.scss
// module id = ./src/app/pages/home/home.component.scss
// module chunks = main